import React, { useEffect, useState } from 'react';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import TimeLine from './TimeLine';
import './SideDrawer.css';
import { getRawTimings } from '../../../services/TimingService';
import { useDispatch, useSelector } from 'react-redux';
import {
  HeaderLoaderAttribute,
  PieChartLoaderAttribute,
  SHOW_NOTIFICATION,
  SNACKBAR_NODATA_MSG,
  TimeLineLoaderAttribute,
  WARNING_KEY,
} from '../../../constants';
import moment from 'moment';
import PieChart from './PieChartComponent';
import KeycloakService from '../../../services/KeycloakService';
import Header from './Header';
import GenericLoader from '../../../components/Loader/GenericLoader';
import { Box } from '@mui/material';

const SideDrawer = (props) => {
  const people = useSelector((state) => state.peopleState);
  const currentUserId = KeycloakService.getUserDetail();
  const [rawTimeData, setRawTimingData] = useState([]);
  const [inTime, setInTime] = useState('');
  const [outTime, setOutTime] = useState('');
  const [finalTimelogIndex, setFinalTimelogIndex] = useState();
  const [timelineloader, setTimelineLoader] = React.useState(true);
  const dispatch = useDispatch();
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const [pieLoader, setPieLoader] = React.useState(
    props.consolidatedPieData ? false : true,
  );
  const [headerLoader, setHeaderLoader] = React.useState(
    props.consolidatedPieData ? false : true,
  );

  useEffect(() => {
    rawTimings();
  }, []);
  const rawTimings = async () => {
    const rawTimingsResponse = await getRawTimings(
      people.id === '' ? currentUserId : people.id,
      moment(props.selectedDate).format('YYYY-MM-DD'),
    );

    if (rawTimingsResponse.isError === false) {
      setStatesFunction(rawTimingsResponse);
      dipatchNotification(rawTimingsResponse.type, rawTimingsResponse.message);
    }
  };
  const ValueTotal = () => {
    let totalValue = 0;
    for (let i = 0; i < props.consolidatedPieData[0].values.length; i++) {
      totalValue = totalValue + props.consolidatedPieData[0].values[i];
    }
    return totalValue;
  };
  const setStatesFunction = (rawTimingsResponse) => {
    setRawTimingData((data) => [...rawTimingsResponse.data]);
    for (let i = 0; i < rawTimingsResponse.data.length; i++) {
      if (
        !rawTimingsResponse.data[i].isArchived &&
        rawTimingsResponse.data[i].direction.toLowerCase() === 'in'
      ) {
        setInTime(rawTimingsResponse.data[i].logTime.slice(0, 5));

        break;
      }
    }
    for (let i = rawTimingsResponse.data.length - 1; i >= 0; i--) {
      if (!rawTimingsResponse.data[i].isArchived) {
        setFinalTimelogIndex(i);
        break;
      }
    }
    for (let i = rawTimingsResponse.data.length - 1; i >= 0; i--) {
      if (
        !rawTimingsResponse.data[i].isArchived &&
        rawTimingsResponse.data[i].direction.toLowerCase() === 'out'
      ) {
        setOutTime(rawTimingsResponse.data[i].logTime.slice(0, 5));
        break;
      }
    }
    !rawTimingsResponse
      ? dipatchNotification(WARNING_KEY, SNACKBAR_NODATA_MSG)
      : setTimelineLoader(false);
  };

  return (
    <>
      <SwipeableDrawer
        className="drawer-width"
        anchor={'right'}
        open={props.drawerOpenFlag}
        onClose={props.closeDrawer('right', false)}
        onOpen={props.closeDrawer('right', true)}
      >
        {headerLoader ? (
          <Box className="div-header">
            <GenericLoader
              rectAttributes={HeaderLoaderAttribute}
              width={430}
              height={50}
              className="all-div-width"
            />
          </Box>
        ) : (
          <Box className="div-header" sx={{ zIndex: '999999' }}>
            <Header
              date={props.selectedDate}
              inTime={inTime}
              outTime={outTime}
            />
          </Box>
        )}
        {ValueTotal() > 0 &&
          (pieLoader ? (
            <Box className="div-piechart">
              <GenericLoader
                rectAttributes={PieChartLoaderAttribute}
                height={400}
                width={400}
                className="all-div-width"
              />
            </Box>
          ) : (
            <Box className="div-piechart">
              <PieChart data={props.consolidatedPieData} />
            </Box>
          ))}
        <Box />
        {rawTimeData.length > 0 &&
          (timelineloader ? (
            <Box>
              <GenericLoader
                rectAttributes={TimeLineLoaderAttribute}
                height={200}
                width={400}
                className="all-div-width"
              />
            </Box>
          ) : rawTimeData.length > 0 ? (
            <TimeLine
              finalTimelogIndex={finalTimelogIndex}
              selectedDate={props.selectedDate}
              rawTimeData={rawTimeData}
            />
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              No Raw Timing Data
            </div>
          ))}
      </SwipeableDrawer>
    </>
  );
};

export default SideDrawer;
